import storeAction from "@/store/typed-actions";
import { Toast } from 'vant';
import router from "@/router";

/**
 * 处理401未授权错误
 * @param {Object} res - API响应数据
 * @param {Function} callback - 跳转前的回调函数（可选）
 */
export function handleUnauthorizedError(res, callback) {
  if (res.code === 401) {
    Toast.fail(res.msg || '登录已过期，请重新登录');
    
    // 清除用户信息
    storeAction.clearCurrentUserId();
    storeAction.clearToken();
    storeAction.delsessionStorage("id");
    storeAction.delsessionStorage("userId");
    storeAction.delsessionStorage("money");
    storeAction.delsessionStorage("idcard");
    storeAction.delsessionStorage("group_id");
    storeAction.setCurrentUserMoney(null);
    
    // 执行回调函数（如果提供）
    if (typeof callback === 'function') {
      callback();
    }
    
    // 跳转到登录页
    router.push('/login');
    return true;
  }
  return false;
}